(() => {
  function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
  }

  class SplitStaticImageSlider {
    constructor(sectionEl) {
      this.section = sectionEl;
      this.track = sectionEl.querySelector(".split-static-slider__track");
      this.slides = Array.from(sectionEl.querySelectorAll(".split-static-slider__slide"));

      this.btnPrev = sectionEl.querySelector("[data-ss-prev]");
      this.btnNext = sectionEl.querySelector("[data-ss-next]");
      this.currentEl = sectionEl.querySelector("[data-ss-current]");
      this.totalEl = sectionEl.querySelector("[data-ss-total]");

      this.index = 0;
      this.slideWidth = 0;

      if (!this.track || this.slides.length === 0) return;

      // Total should count only slide blocks (not section.blocks.size if you add other block types later)
      if (this.totalEl) this.totalEl.textContent = String(this.slides.length);

      this.onResize = this.onResize.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);

      this.track.addEventListener("scroll", this.onScroll, { passive: true });
      window.addEventListener("resize", this.onResize);

      if (this.btnPrev) this.btnPrev.addEventListener("click", this.onPrev);
      if (this.btnNext) this.btnNext.addEventListener("click", this.onNext);

      this.onResize();
      this.updateUI();
    }

    onResize() {
      const first = this.slides[0];
      this.slideWidth = first ? first.getBoundingClientRect().width : 0;
      this.snapToIndex(this.index, false);
      this.updateUI();
    }

    onScroll() {
      if (!this.slideWidth) return;

      const raw = this.track.scrollLeft / this.slideWidth;
      const nextIndex = clamp(Math.round(raw), 0, this.slides.length - 1);

      if (nextIndex !== this.index) {
        this.index = nextIndex;
        this.updateUI();
      }
    }

    onPrev() {
      this.snapToIndex(this.index - 1, true);
    }

    onNext() {
      this.snapToIndex(this.index + 1, true);
    }

    snapToIndex(next, smooth = true) {
      const i = clamp(next, 0, this.slides.length - 1);
      this.index = i;

      const left = this.slideWidth * i;
      this.track.scrollTo({
        left,
        behavior: smooth ? "smooth" : "auto",
      });

      this.updateUI();
    }

    updateUI() {
      if (this.currentEl) this.currentEl.textContent = String(this.index + 1);
      if (this.btnPrev) this.btnPrev.disabled = this.index === 0;
      if (this.btnNext) this.btnNext.disabled = this.index === this.slides.length - 1;
    }
  }

  function init() {
    document.querySelectorAll(".split-static-slider[data-section-id]").forEach((section) => {
      if (section.__splitStaticSliderInit) return;
      section.__splitStaticSliderInit = true;
      new SplitStaticImageSlider(section);
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();